import React, { ReactNode } from 'react'

function MainLayout({ children }: { children: ReactNode }) {
  return <div className='flex h-full w-full flex-col overflow-y-auto'>{children}</div>
}

export default MainLayout
